<template>
  <v-snackbar
    v-model="alert"
    color="#161520"
    :timeout="6000"
    top
    multi-line
  >
    <span v-html="alertMessage"></span>
    <v-btn
      dark
      text
      :color="alertType === 'error' ? '#f12d57' : '#44d22d'"
      @click="changeState(false)"
    >
      {{ $t("ask-box.snackbar.btn-1") }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { VBtn, VSnackbar } from 'vuetify/lib'

export default {
  components: {
    VBtn: VBtn,
    VSnackbar: VSnackbar
  },
  props: {
    alert: {
      type: Boolean,
      default: () => false
    },
    alertType: {
      type: String,
      default: () => 'error'
    },
    alertMessage: {
      type: String,
      default: function () {
        return this.$t('basic-message.error-message')
      }
    }
  },

  methods: {
    changeState (value) {
      this.$emit('changeHTTPBoxState', value)
    }
  }
}
</script>
